import React from "react";
import Box from "@mui/material/Box";
import BankingNavigationMenu from "./BankingNavigationMenu";

export default function Banking() {
  return (
    <>
      <Box>
        <BankingNavigationMenu />
      </Box>
    </>
  );
}
